module.exports = __webpack_public_path__ + "media/common/icon-arrow-left-10a02582.svg";